import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { CategoryCreate, CategoryEntity, CategoryItem, CategoryUpdate } from '@models';
import { map, Observable } from 'rxjs';
import { APIHelper } from '@controladad/ng-base';

@Injectable({
  providedIn: 'root',
})
export class CategoryApiService extends BaseApi<CategoryEntity, CategoryCreate, CategoryUpdate> {
  constructor() {
    super('/AdminPanel/Category', {
      get: '/AdminPanel/GetCategoryList',
      post: '/AdminPanel/AddCategory',
      getById: '/AdminPanel/GetCategoryDetails',
    });
  }

  override get(id: number): Observable<CategoryEntity> {
    return http$
      .get<Omit<CategoryEntity, 'id'>>(`/AdminPanel/GetCategoryDetails?CategoryId=${id}`)
      .pipe(map((v) => ({ ...v, id })));
  }

  // @ts-ignore
  override getAll(): Observable<CategoryItem[]> {
    return super.getAll<CategoryItem>();
  }

  // @ts-ignore
  override delete(id: number) {
    return http$.delete('/AdminPanel/DeleteCategory', { body: { categoryId: id } });
  }

  // @ts-ignore
  override update(model: CategoryUpdate) {
    const parentId = model.fields.parentId;
    return http$.put('/AdminPanel/EditCategory', {
      categoryId: model.categoryId,
      fields: {
        ...APIHelper.nestValues(model.fields),
        parentId: parentId !== undefined ? { value: parentId } : null,
      },
    });
  }

  getFlatCategories(): Observable<{ value: number; label: string }[]> {
    return this.getAll().pipe(
      map((categories: CategoryItem[]) => {
        const flatCategories: { value: number; label: string }[] = [];

        const addCategoriesRecursively = (categories: CategoryItem[]) => {
          categories.forEach((category: CategoryItem) => {
            flatCategories.push({
              value: category.id,
              label: category.name.english || category.name.arabic
            });

            if (category.subCategories && category.subCategories.length > 0) {
              addCategoriesRecursively(category.subCategories);
            }
          });
        };

        addCategoriesRecursively(categories);
        return flatCategories;
      })
    );
  }
}
